import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEmriIPerdoruesit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "#fff",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8,8c2.2,0,4-1.8,4-4s-1.8-4-4-4S4,1.8,4,4 S5.8,8,8,8z M8,10c-2.7,0-8,1.3-8,4v1c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-1C16,11.3,10.7,10,8,10z" })
});
export { SvgIconEmriIPerdoruesit as ReactComponent };
